import { render } from "./RepairGuideImage.vue?vue&type=template&id=83112b6a&scoped=true"
import script from "./RepairGuideImage.vue?vue&type=script&lang=js"
export * from "./RepairGuideImage.vue?vue&type=script&lang=js"

import "./RepairGuideImage.vue?vue&type=style&index=0&id=83112b6a&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83112b6a"]])

export default __exports__